/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { BadgeProps } from './Badge.props';

/**
 * SDS Badge component.
 */
export const Badge = (props: BadgeProps): JSX.Element => {
  const { classes, left, right, state, type, ...rest } = props;
  const badgeClass = clsx(`sds-badge`, `badge--${type}`, classes, {
    [`badge--${state}`]: state !== undefined,
  });

  return (
    <div className={badgeClass} {...rest}>
      <span className="sds-badge-label sds-badge-label--left">{left}</span>
      {right && <span className="sds-badge-label sds-badge-label--right">{right}</span>}
    </div>
  );
};
